import { getAccounts } from './methods/get-accounts'
import { getProperties } from './methods/get-properties'
import { checkAuth } from './methods/check-auth'
import { selectAccount } from './methods/select-account'
import { selectProperty } from './methods/select-property'
import { checkDuplicateAccount } from './methods/check-duplicate-account'

export const googleActions = {
  getAccounts,
  getProperties,
  checkAuth,
  selectAccount,
  selectProperty,
  checkDuplicateAccount
}

export {
  getAccounts,
  getProperties,
  checkAuth,
  selectAccount,
  selectProperty,
  checkDuplicateAccount
}
